import { Content } from 'src/contexts/ContentContext';
import { PosDropdownItem } from 'src/core/POS/PosDropdown';
import { useUserHasAnyOfPermissions } from 'src/hooks/useUserHasAnyOfPermissions';
import { ContentId } from 'src/utils/constants/contentId';
import { Permission } from 'src/WebApiController';

export const LaunchChangeEvent = ({
  onClick,
  disabled,
}: {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
}) => {
  const hasPermission = useUserHasAnyOfPermissions(
    Permission.Inventory_UpdateListingInfo,
    Permission.Inventory_UpdateListingInfoOnIsPricerOf,
    Permission.Inventory_UpdateListingInfoOnPurchasedBy
  );

  if (!hasPermission) {
    return null;
  }

  return (
    <>
      <PosDropdownItem key="changeEvent" onClick={onClick} disabled={disabled}>
        <Content id={ContentId.ChangeEvent} />
      </PosDropdownItem>
    </>
  );
};
